function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';
import { getClassNames } from './Grid.classNames';
export class Col extends React.Component {
  render() {
    const {
      children,
      className = '',
      tag = 'div'
    } = this.props;
    return /*#__PURE__*/React.createElement(tag, {
      className: `${getClassNames(this.props).col} ${className}`
    }, children);
  }

}

_defineProperty(Col, "displayName", 'GridCol');